/* eslint-disable @typescript-eslint/no-unused-vars */
import styled, { css } from 'styled-components';
import { themeToken } from "../../utils/cpds-utils";

/* Note: By default, this component is rendered as a 'div' element. 
If your use case requires a different HTML element, please update the component accordingly.
Get the the token please use cpds props ex: ${cpds?.button_primary_background_color} 

Start styles for component here
Your Styles goes here  
End styles for component here

Styles overrides - Do not Remove This Code Block
Data feed styles overrides goes here

*/
// Styled components
const Container = styled.div`
${({ theme: { styles: { cpds } }, ...props }) => {
  const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
  
  return css`
    width: 100%;
    background-color: ${token?.subtitle_paragraph_background_color};
    ${(props) => props?.styleOverrides}
  `}
  }
`;

const ContentWrpper = styled.div`
${({ theme: { styles: { cpds } }, ...props }) => {

  return css`
    max-width: 650px;
    margin: 0 auto;
    padding: 20px;
    text-align: ${props?.contentAlignment || 'left'};
    ${(props) => props?.styleOverrides}
  `}
  }
`;

const Title = styled.h3`
${({ theme: { styles: { cpds } }, ...props }) => {
  const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
 
  return css`
    margin-bottom: 24px;
    color: ${token?.subtitle_paragraph_title_color};
  `}
  }
`;

const Content = styled.p`
${({ theme: { styles: { cpds } }, ...props }) => {
  const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
 
  return css`
    color: ${token?.subtitle_paragraph_content_color};
    margin-bottom: 24px;
  `}
  }
`;

const MetaInfo = styled.div`
${({ theme: { styles: { cpds } }, ...props }) => {
  const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
 
  return css`
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-top: 1px solid ${token.subtitle_paragraph_separator_border_color};
    padding-top: 32px;
    margin-top: 20px;
  `}
  }
`;

const MetaWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

const Category = styled.div`
  display: flex;
  gap: 10px;
`;

const AuthorInfo = styled.div`
${({ theme: { styles: { cpds } }, ...props }) => {
  const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
 
  return css`
    color: ${token.subtitle_paragraph_author_color};
    display: flex;
    flex-direction: column;
    text-align: left;
    margin-top: 8px;
  `}
  }
`;

const SponsoredBy = styled.div`
${({ theme: { styles: { cpds } }, ...props }) => {
  const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
 
  return css`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    color: ${token.subtitle_paragraph_date_color};
    gap: 8px;
  `}
  }
`;

const Tag = styled.span`
${({ theme: { styles: { cpds } }, ...props }) => {
  const { token } = themeToken(cpds, cpds?.themeColorMode, props?.themeColorMode);
 
  return css`
    border-bottom: 1px solid ${token.subtitle_paragraph_tag_border_color};
    padding-bottom: 6px;
    color: ${token.subtitle_paragraph_tag_color};
  `}
  }
`;

export { Container, ContentWrpper, Title, Content, MetaInfo, Category, AuthorInfo, SponsoredBy, MetaWrapper, Tag };
